import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { AuthAccount2, AuthLocation } from "../../../graphql/types"
import { OrganizationData } from "../../auth/types"

export const LOG_OUT_CLICKED = "logOut/clicked"

export const logOutClicked = () => ({
    type: LOG_OUT_CLICKED,
})

export const LOG_OUT_SUCCESS = "logOut/success"

export const logOutSuccess = (message?: Maybe<string>) => ({
    type: LOG_OUT_SUCCESS,
    payload: {
        message: message,
    },
})

export const LOG_OUT_FAILURE = "logOut/failure"

export const logOutFailure = (error: any) => ({
    type: LOG_OUT_FAILURE,
    payload: {
        error: error,
    },
})

export const LOAD_ACCOUNTS_SUCCESS = "loadAccounts/success"

export const loadAccountsSuccess = (accounts: AuthAccount2[], redirectToSelectAccountScreen?: boolean) => ({
    type: LOAD_ACCOUNTS_SUCCESS,
    payload: {
        accounts: accounts,
        redirectToSelectAccountScreen: redirectToSelectAccountScreen,
    },
})

export const LOAD_ACCOUNTS_FAILURE = "loadAccounts/failure"

export const loadAccountsFailure = (error: any) => ({
    type: LOAD_ACCOUNTS_FAILURE,
    payload: {
        error: error,
    },
})

export const LOAD_ORGANIZATIONS_SUCCESS = "loadOrganizations/success"

export const loadOrganizationsSuccess = (organizations: OrganizationData[]) => ({
    type: LOAD_ORGANIZATIONS_SUCCESS,
    payload: {
        organizations: organizations,
    },
})

export const LOAD_AUTH_LOCATIONS_SUCCESS = "loadAuthLocations/success"

export const loadAuthLocationsSuccess = (locations: AuthLocation[], masterListAccess: boolean) => ({
    type: LOAD_AUTH_LOCATIONS_SUCCESS,
    payload: {
        locations: locations,
        masterListAccess: masterListAccess,
    },
})

export const LOAD_LOCATIONS_FAILURE = "loadLocations/failure"

export const loadAuthLocationsFailure = (error: any) => ({
    type: LOAD_LOCATIONS_FAILURE,
    payload: {
        error: error,
    },
})

export const ACCOUNT_SELECT_CLICKED = "accountSelect/clicked"

export const accountSelectClicked = (accountId: string) => ({
    type: ACCOUNT_SELECT_CLICKED,
    payload: {
        accountId: accountId,
    },
})
